<script setup>
/**
 * Shown directly below every primary "Weiter" / submit button in the
 * lead funnel. The button click itself is the affirmative action
 * (UWG § 7 Abs. 2 Nr. 2 / DSGVO Art. 6 Abs. 1 lit. a). Repeating the
 * same notice on every step is legally stronger, not weaker — the user
 * sees what they're agreeing to at each clickable moment.
 *
 * TODO: LAWYER_REVIEW — final wording must be signed off before prod.
 */
defineProps({
    brand: {
        type: String,
        default: '',
    },
    color: {
        type: String,
        default: '#737373',
    },
});
</script>

<template>
    <p :style="{ fontSize: '10.5px', color, lineHeight: '1.5', textAlign: 'left', marginTop: '8px' }">
        Mit Klick auf „Weiter" willige ich ein, dass
        <strong>{{ brand || 'dieses Portal' }}</strong>
        und ausgewählte Fachbetriebe mich telefonisch, per SMS oder E-Mail zur Angebotserstellung kontaktieren dürfen.
        Widerruf jederzeit.
        Ihre Daten werden SSL-verschlüsselt übertragen und nur an regionale Fachbetriebe weitergegeben.
        <a
            href="/datenschutz"
            target="_blank"
            rel="noopener"
            :style="{ color: 'var(--brand-accent-fg, var(--brand-accent))', textDecoration: 'underline' }"
        >
            Datenschutz
        </a>
    </p>
</template>
